/**
 * UIContext — backward-compatible facade.
 *
 * ⚠️  DEPRECATED: Use the split contexts instead:
 *   - useNotification() from './NotificationContext'
 *   - useLoading()       from './LoadingContext'
 *
 * This file is kept to avoid breaking existing call sites during migration.
 * Once all consumers are updated, this file can be deleted.
 *
 * The actual rendering of toasts and progress bar has moved to
 * NotificationContext and LoadingContext respectively.
 */

export { NotificationProvider, useNotification } from './NotificationContext';
export { LoadingProvider, useLoading } from './LoadingContext';

// Legacy: UIProvider wraps both split providers for one-line migration in main.tsx
import React, { ReactNode } from 'react';
import { NotificationProvider } from './NotificationContext';
import { LoadingProvider } from './LoadingContext';

export const UIProvider: React.FC<{ children: ReactNode }> = ({ children }) => (
  <NotificationProvider>
    <LoadingProvider>
      {children}
    </LoadingProvider>
  </NotificationProvider>
);

// Legacy useUI hook — combines both contexts for backward compat
import { useNotification } from './NotificationContext';
import { useLoading } from './LoadingContext';

export const useUI = () => {
  const { notify } = useNotification();
  const { loading, setLoading } = useLoading();
  return { notify, loading, setLoading };
};
